var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header custom-color-header-background" },
    [
      _vm._t("default", null, {
        onShowMainNaviButtonClick: _vm.onShowMainNaviButtonClick,
        onCloseMainNaviButtonClick: _vm.onCloseMainNaviButtonClick,
        showMainNavi: _vm.showMainNavi,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }